import { z } from 'zod';
import { EditorialStatusSchema } from './workspace-content';

/**
 * Platform activity for administrators (M6, ADR-029): counts and costs only. Nothing here
 * identifies a person or holds a question, chat, memo or report text.
 */

export const ActivityDaySchema = z.object({
  day: z.string(),
  answered: z.number().int(),
  failed: z.number().int(),
  refused: z.number().int(),
  costUsd: z.number(),
});
export type ActivityDay = z.infer<typeof ActivityDaySchema>;

export const OperationsReportSchema = z.object({
  generatedAt: z.string(),
  ai: z.object({
    month: z.string(),
    budgetUsd: z.number(),
    committedUsd: z.number(),
    spentUsd: z.number(),
    /** Requests whose cost was estimated (stopped mid-way, lost connection). */
    unreconciled: z.number().int(),
    /** The last 14 days, oldest first. */
    days: z.array(ActivityDaySchema),
    period: z.object({
      requests: z.number().int(),
      completed: z.number().int(),
      notFound: z.number().int(),
      declined: z.number().int(),
      failed: z.number().int(),
      refusedBudget: z.number().int(),
      refusedAllowance: z.number().int(),
      /** Still "started": running now, or stopped by the platform. */
      open: z.number().int(),
      costUsd: z.number(),
      medianSeconds: z.number().nullable(),
      byTask: z.record(z.string(), z.number().int()),
    }),
  }),
  content: z.object({
    accounts: z.number().int().nullable(),
    acts: z.number().int(),
    cases: z.number().int(),
    chats: z.number().int().nullable(),
    memos: z.number().int().nullable(),
    openReports: z.number().int().nullable(),
    reviews: z.partialRecord(EditorialStatusSchema, z.number().int()),
  }),
});
export type OperationsReport = z.infer<typeof OperationsReportSchema>;
